import http from '@/utils/http'
import { user } from '@/api/url'

/**
 * user
 *
 * @author Shigq
 * @date 2021/5/19 12:01
 */
export function register(param) {
  return http({
    url: user.register,
    method: 'post',
    useCommon: true,
    data: param
  })
}

export function getRegisterInfo(param) {
  return http({
    url: user.getRegisterInfo,
    method: 'post',
    data: param
  })
}

export function sendMobilePhoneCode(param) {
  return http({
    url: user.sendMobilePhoneCode,
    method: 'post',
    data: param
  })
}

export function sendEmailCode(param) {
  return http({
    url: user.sendEmailCode,
    method: 'post',
    data: param
  })
}

export function checkEmail(param) {
  return http({
    url: user.checkEmail,
    method: 'post',
    showErrMsg: false,
    data: param
  })
}

export function login(param) {
  return http({
    url: user.login,
    method: 'post',
    data: param
  })
}

export function logout(param) {
  return http({
    url: user.logout,
    method: 'post',
    data: param
  })
}

// 获取用户信息
export function getUserInfo(param) {
  return http({
    url: user.getUserInfo,
    method: 'post',
    data: { ...param }
  })
}

// 修改密码
export function modifyPassword(param) {
  return http({
    url: user.modifyPassword,
    method: 'post',
    data: { ...param }
  })
}

export function resetPasswordByCellphone(param) {
  return http({
    url: user.resetPasswordByCellphone,
    method: 'post',
    useCommon: true,
    data: param
  })
}

export function resetPasswordByEmail(param) {
  return http({
    url: user.resetPasswordByEmail,
    method: 'post',
    useCommon: true,
    data: param
  })
}

export function bindingEmail(param) {
  return http({
    url: user.bindingEmail,
    method: 'post',
    useCommon: true,
    data: { ...param }
  })
}
